import type {
  AcuityApproversResponse,
  AcuityHistoryResponse,
  AcuityResolutionPayload,
  AcuityResolutionResponse,
  PostAcuityScoreResponse,
  UUID,
  PostAcuityScorePayload,
  ReasoningOptionsResponse,
  CurrentAcuityScoreResponse,
} from "@/core/types";
import type { ApiParams, AptiRequestConfig } from "@/lib/types/api";
import { getGroupAuthType } from "@/redux/actions/auth";
import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios";
import { httpAuth } from "@/utils/axios";

export const acuityRequestsTyped = {
  get_acuity_history: function ({
    params,
    patientId,
  }: {
    params?: ApiParams;
    patientId: UUID;
  }): Promise<AcuityHistoryResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "GET",
      params,
      preventAllErrorToast: true,
      url: `/v1/acuity_score/patient/${patientId}/history`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<AcuityHistoryResponse>;
  },

  get_approvers: function ({
    params,
  }: { params?: ApiParams } = {}): Promise<AcuityApproversResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "GET",
      params,
      preventAllErrorToast: true,
      url: "/v1/acuity_score/approvers",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<AcuityApproversResponse>;
  },

  get_current_acuity_score: function ({
    params,
    patientId,
  }: {
    params?: ApiParams;
    patientId: UUID;
  }): Promise<CurrentAcuityScoreResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "GET",
      params,
      preventAllErrorToast: true,
      url: `/v1/acuity_score/patient/${patientId}/current`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<CurrentAcuityScoreResponse>;
  },

  get_reasoning_options: function ({
    params,
  }: { params?: ApiParams } = {}): Promise<ReasoningOptionsResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "GET",
      params,
      preventAllErrorToast: true,
      url: "/v1/acuity_score/reasoning_options",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<ReasoningOptionsResponse>;
  },

  post_acuity_resolution: function ({
    data,
    params,
    patientId,
  }: {
    data: AcuityResolutionPayload;
    params?: ApiParams;
    patientId: UUID;
  }): Promise<AcuityResolutionResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      preventAllErrorToast: true,
      url: `/v1/acuity_score/patient/${patientId}/resolution`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<AcuityResolutionResponse>;
  },

  post_acuity_score: function ({
    data,
    params,
    patientId,
  }: {
    data: PostAcuityScorePayload;
    params?: ApiParams;
    patientId: UUID;
  }): Promise<PostAcuityScoreResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      preventAllErrorToast: true,
      url: `/v1/acuity_score/patient/${patientId}/request`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PostAcuityScoreResponse>;
  },
};
